const map = {
	"./1.jpg": "./src/assets/images/dashboard/user/1.jpg",
	"./10.jpg": "./src/assets/images/dashboard/user/10.jpg",
	"./11.jpg": "./src/assets/images/dashboard/user/11.jpg",
	"./12.jpg": "./src/assets/images/dashboard/user/12.jpg",
	"./13.jpg": "./src/assets/images/dashboard/user/13.jpg",
	"./2.jpg": "./src/assets/images/dashboard/user/2.jpg",
	"./3.jpg": "./src/assets/images/dashboard/user/3.jpg",
	"./4.jpg": "./src/assets/images/dashboard/user/4.jpg",
	"./5.jpg": "./src/assets/images/dashboard/user/5.jpg",
	"./6.jpg": "./src/assets/images/dashboard/user/6.jpg",
	"./7.jpg": "./src/assets/images/dashboard/user/7.jpg",
	"./8.jpg": "./src/assets/images/dashboard/user/8.jpg",
	"./9.jpg": "./src/assets/images/dashboard/user/9.jpg"
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images/dashboard/user sync recursive ^\\.\\/.*\\.jpg$";